// src/pages/PersonalisedCustomerCare.js
import React from 'react';
import FeaturePageLayout from '../components/FeaturePageLayout';
import { 
    IoHeartOutline, 
    IoFlashOutline, 
    IoPeopleCircleOutline, 
    IoSyncOutline 
} from 'react-icons/io5';
import image1 from '../assets/images/Messages.png';
import image2 from '../assets/images/Messages2.png';
import image3 from '../assets/images/Generate.png';
import image4 from '../assets/images/Analytics.png';
import heroBg from '../assets/images/customer-care-background.png';

const breadcrumbSchema = { "@context": "https://schema.org", "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://oolook.in/" }, { "@type": "ListItem", "position": 2, "name": "Personalised Customer Care", "item": "https://oolook.in/personalised-customer-care" }] };
const serviceSchema = { "@context": "https://schema.org", "@type": "Service", "serviceType": "Customer Support Software", "provider": { "@type": "Organization", "name": "Oolook" }, "name": "AI-Powered Social Customer Care", "description": "Deliver exceptional, personalized customer care on social media with Oolook's Unified Inbox and AI-powered smart replies.", "url": "https://oolook.in/personalised-customer-care" };

const pageData = {
  seo: {
    title: "AI-Powered Social Customer Care | Oolook",
    description: "Deliver faster, smarter, and more personalized customer support on social media. Oolook's Unified Inbox and AI tools help you build loyalty with every interaction.",
    image: 'https://oolook.in/og/customer-care.png',
    schemas: [breadcrumbSchema, serviceSchema]
  },
  hero: {
    icon: IoHeartOutline,
    title: "Exceptional Service, Effortlessly Delivered",
    subtitle: "Turn every customer interaction into an opportunity to build loyalty. Oolook centralizes your conversations and empowers your team with AI to deliver fast, personalized care.",
    backgroundImage: heroBg
  },
  featureSection: {
    title: "A Unified Hub for Customer Conversations",
    subtitle: "Manage every comment, DM, and mention across all platforms from one smart inbox, built for speed and collaboration.",
    features: [
      { title: "One Inbox, Every Platform", description: "Consolidate all your customer conversations from Facebook, Instagram, X, and more into a single, organized view.", image: image1 },
      { title: "AI-Powered Smart Replies", description: "Answer common questions instantly with AI-generated replies that learn your brand's voice, freeing up your team for complex issues.", image: image3 },
      { title: "Team Collaboration Tools", description: "Assign conversations, leave internal notes, and create a seamless support experience, even with a distributed team.", image: image2 },
      { title: "Sentiment Analysis", description: "Our AI automatically detects the sentiment of incoming messages, helping you prioritize urgent requests and identify happy customers.", image: image4 }
    ]
  },
  benefitGrid: {
    title: "The ROI of Outstanding Customer Care",
    benefits: [
      { icon: IoFlashOutline, title: "Increase Response Speed", description: "Slash your first-response times and resolve customer issues faster than ever before." },
      { icon: IoPeopleCircleOutline, title: "Boost Customer Loyalty", description: "Personalized, timely care turns one-time buyers into lifelong brand advocates." },
      { icon: IoSyncOutline, title: "Improve Team Efficiency", description: "Automate repetitive tasks and empower your support team to handle more conversations with less effort." },
      { icon: IoHeartOutline, title: "Enhance Brand Reputation", description: "Build a reputation for world-class customer service that sets you apart from the competition." }
    ]
  },
  stepByStep: {
    title: "Streamline Your Support Workflow",
    subtitle: "Go from chaotic notifications to a calm, organized customer care hub in minutes.",
    steps: [
      { title: "1. Connect Your Accounts", description: "Link your social profiles, and Oolook will instantly import all your conversations into the Unified Inbox." },
      { title: "2. Configure Smart Replies", description: "Provide the AI with answers to your most common questions to enable one-click, on-brand responses." },
      { title: "3. Set Up Team Assignments", description: "Create rules to automatically assign conversations to the right team members based on platform or keyword." },
      { title: "4. Start Engaging Smarter", description: "Watch your team's efficiency soar as you manage your community with powerful AI tools and a perfectly organized workflow." }
    ]
  },
  targetAudience: {
    title: "The Essential Toolkit for Modern Support Teams"
  }
};

const PersonalisedCustomerCare = () => {
  return <FeaturePageLayout pageData={pageData} />;
};

export default PersonalisedCustomerCare;